import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from "recharts";

const datas = [
  {
    subject: "心理的な仕事の負担（量）",
    A: 120,
    B: 110,
    fullMark: 150,
  },
  {
    subject: "心理的な仕事の負担（質）",
    A: 98,
    B: 130,
    fullMark: 150,
  },
  {
    subject: "自覚的な身体的負担度",
    A: 86,
    B: 130,
    fullMark: 150,
  },
  {
    subject: "職場の対人関係でのストレス",
    A: 99,
    B: 100,
    fullMark: 150,
  },
  {
    subject: "職場環境によるストレス",
    A: 85,
    B: 90,
    fullMark: 150,
  },
  {
    subject: "仕事のコントロール度",
    A: 65,
    B: 85,
    fullMark: 150,
  },
  {
    subject: "あなたの技能の活用度",
    A: 99,
    B: 100,
    fullMark: 150,
  },
  {
    subject: "あなたが感じている仕事の適性度",
    A: 85,
    B: 90,
    fullMark: 150,
  },
  {
    subject: "働きがい",
    A: 65,
    B: 85,
    fullMark: 150,
  },
];

const CustomTick = ({ payload, x, y, textAnchor, stroke, radius }: any) => {
  return (
    // <g className="recharts-layer recharts-polar-angle-axis-tick">
    //   <text
    //     radius={radius}
    //     stroke={stroke}
    //     x={x}
    //     y={y}
    //     width={80}
    //     fontSize={10}
    //     fontWeight={500}
    //     className="recharts-text recharts-polar-angle-axis-tick-value"
    //     textAnchor={textAnchor}
    //   >
    //     <tspan x={x} dy="0em">
    //       {payload.value}
    //     </tspan>
    //   </text>
    // </g>
    <g className="recharts-layer recharts-polar-angle-axis-tick">
      <text
        radius={radius}
        stroke={stroke}
        x={x}
        y={y}
        textAnchor={textAnchor}
        width={60}
        height={100}
        fontSize={10}
        fontWeight={500}
        className="recharts-text recharts-polar-angle-axis-tick-value"
      >
        <tspan x={x} dy="0em">
          {payload.value}
        </tspan>
      </text>
    </g>
  );
};

const RadarChartCustom = ({ data }: any) => {
  const max = data?.length > 0 ? data[0].fullMark : 0;
  return (
    <div style={{ width: "100%", height: "280px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" tick={<CustomTick />} />
          <PolarRadiusAxis
            angle={max / 5}
            domain={[0, max]}
            tick={false}
            axisLine={false}
          />
          <Radar name="Mike" dataKey="A" fill="#2F8CAE" fillOpacity={0.75} />
          <Radar name="Lily" dataKey="B" fill="#2F8CAE" fillOpacity={0.25} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarChartCustom;
